<template>
  <fragment>
    <AppBody title="Ranking" subtitle="Ranking de Afiliados">
      <v-card class="justify-center">
        <v-col cols="12">
          <v-alert color="blue" type="info"
            >Escolha uma rede de afiliados à qual você pertença para visualizar
            o ranking.</v-alert
          >
          <label class="input-labels"> Rede de Afiliados </label>
          <v-autocomplete
            v-model="selectedNetwork"
            :items="networkItems"
            solo
            class="textDropdown"
            label="Selecione uma rede de afiliados"
            chip
            deletable-chips
            clear-icon="mdi-close-circle-outline"
            item-value="value"
            item-text="text"
            no-data-text="Nenhuma rede de afiliados encontrada"
            :color="$config.dados.corinputs"
            :item-color="$config.dados.corinputs"
            :loading="loadingSale"
          >
          </v-autocomplete>
        </v-col>
        <v-row
          v-if="podiumData.length > 0"
          no-gutters
          class="mb-4 mt-4 justify-center align-end"
        >
          <v-col cols="3" class="text-center">
            <p class="text-center text-h6" style="font-weight: bold">
              {{ podiumDataName(1) }}
            </p>
            <v-card
              class="text-center"
              style="
                background-color: #c0c0c0;
                height: 120px;
                justify-content: center;
                align-items: center;
                display: flex;
              "
            >
              <p class="text-h2">{{ podiumDataPosition(1) }}</p>
            </v-card>
          </v-col>
          <v-col cols="3" class="text-center">
            <p class="text-center text-h6" style="font-weight: bold">
              {{ podiumDataName(0) }}
            </p>
            <v-card
              class="text-center"
              style="
                background-color: #d4af37;
                height: 180px;
                justify-content: center;
                align-items: center;
                display: flex;
              "
            >
              <v-icon color="" :size="mdAndUp ? 100 : 50">mdi-trophy</v-icon>
            </v-card>
          </v-col>
          <v-col cols="3" class="text-center">
            <p class="text-center text-h6" style="font-weight: bold">
              {{ podiumDataName(2) }}
            </p>
            <v-card
              class="text-center"
              style="
                background-color: #cd7f32;
                height: 80px;
                justify-content: center;
                align-items: center;
                display: flex;
              "
            >
              <p class="text-h3">{{ podiumDataPosition(2) }}</p>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="12" md="5">
            <v-data-table
              :headers="headers"
              :items="ranking"
              class="table-body"
              no-data-text="Não há registro de ranking para ser exibidos"
              loading-text="Buscando informações do ranking..."
              item-key="idprograma"
              :items-per-page="10"
              :search="search"
              :loading="loadingRanking"
              :footer-props="{
                itemsPerPageOptions: [10, 20, 50, 100],
                itemsPerPageText: 'Redes por página',
              }"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Busque pelo nome do afiliado"
                  class="mx-4"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  :color="$config.dados.corinputs"
                ></v-text-field>
              </template>
              <template v-slot:item.posicao="{ item }">
                <v-icon
                  v-if="item.posicao && [1, 2, 3].includes(item.posicao)"
                  :value="item.posicao"
                  :color="getPodiumColor(item.posicao)"
                  >mdi-star-circle</v-icon
                >
                {{ item.posicao || "Sem Rank" }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </AppBody>
  </fragment>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "Ranking",
  mixins: [displayHelpers],
  components: {
    AppBody,
  },
  data() {
    return {
      selectedNetwork: null,
      search: "",
      headers: [
        {
          text: "Rank",
          value: "posicao",
          align: "center",
          sortable: false,
        },
        {
          text: "Nome",
          value: "nome",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchRanking", "fetchSaleByAffiliateId"]),
    getPodiumColor(posicao) {
      if (posicao === 1) {
        return "#d4af37";
      } else if (posicao === 2) {
        return "#c0c0c0";
      } else if (posicao === 3) {
        return "#cd7f32";
      } else {
        return "";
      }
    },
    podiumDataName(index) {
      return this.podiumData[index]?.nome || "Sem informações";
    },
    podiumDataPosition(index) {
      return this.podiumData[index]?.posicao || "N/A";
    },
  },
  computed: {
    ...mapGetters([
      "ranking",
      "userInfo",
      "sale",
      "loadingSale",
      "loadingRanking",
    ]),
    networkItems() {
      return this.sale?.PROGRAMAS?.map(item => ({
        text: item.nome_programa,
        value: item.idprograma,
      }));
    },
    podiumData() {
      return this.ranking.slice(0, 3);
    },
  },
  watch: {
    selectedNetwork() {
      this.fetchRanking({
        idprograma: this.selectedNetwork,
      });
    },
  },
  mounted() {
    if (this.sale.length < 1) {
      this.fetchSaleByAffiliateId({
        id: this.userInfo.idafiliado,
      });
    }
  },
};
</script>

<style>
.v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  bottom: 0px !important;
}
</style>
